module.exports = __webpack_public_path__ + "static/img/12.e1faf4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/12.png
// module id = 2drO
// module chunks = 0